import { ColorIdToName } from "common/materials/library/colorIdToName";
import { LayerConfigIdToName } from "common/materials/library/layerConfigIdToName";
import { TemplateIdToName } from "common/materials/library/templateIdToName";
import type { MaterialSrc } from "common/materials/materialSrc";

export function logMaterialSrc(materialSrc: MaterialSrc, prettyFormat = false): string {
  const template = TemplateIdToName[materialSrc.templateId];
  const layerConfig =
    materialSrc.layerConfigId !== undefined ? LayerConfigIdToName[materialSrc.layerConfigId] : undefined;
  const color = materialSrc.colorId !== undefined ? ColorIdToName[materialSrc.colorId] : undefined;
  if (prettyFormat) {
    let str = "template: " + template;
    if (layerConfig) {
      str += "\nlayer config: " + layerConfig;
    }
    if (color) {
      str += "\ncolor: " + color;
    }
    return str;
  } else {
    return JSON.stringify({ template, layerConfig, color });
  }
}
